/** Non-empty trimmed lines from textarea input (preserves line order). */
export function getUrlLines(value) {
  if (!value || typeof value !== 'string') return []
  return value
    .split(/\r?\n/)
    .map(line => line.trim())
    .filter(Boolean)
}

/** Valid absolute http(s) URL. */
export function isValidHttpUrl(str) {
  if (!str || typeof str !== 'string') return false

  const value = str.trim()
  if (!value) return false

  const httpUrlPattern =
    /^(https?):\/\/(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}|localhost|(?:\d{1,3}\.){3}\d{1,3})(?::\d{1,5})?(?:[/?#][^\s]*)?$/i

  if (!httpUrlPattern.test(value)) return false

  const hostMatch = value.match(/^https?:\/\/([^/:?#]+)(?::(\d{1,5}))?/i)
  if (!hostMatch) return false

  const host = hostMatch[1]
  const port = hostMatch[2]

  if (/^\d{1,3}(?:\.\d{1,3}){3}$/.test(host)) {
    const octets = host.split('.').map(Number)
    if (octets.some(octet => octet < 0 || octet > 255)) return false
  }

  if (port) {
    const portNumber = Number(port)
    if (portNumber < 1 || portNumber > 65535) return false
  }

  return true
}
